import { format } from 'date-fns';
import moment from 'moment';
import { dateToSaveFormat } from '~/constants';
import { Helper } from '~/utils/helper';

export function convertBrowserDateToServerDate(date: string | number): string {
    return format(new Date(date), dateToSaveFormat);
}

export function convertServerDateToBrowserDate(date: string): string {
    return moment(Helper.UtcToLocalTime(date)).format('MM/DD/YYYY');
}

export function convertServerDateToBrowserDateAndTime(date: string) {
    return moment(Helper.UtcToLocalTime(date)).format('YYYY-MM-DD HH:mm:ss');
}
